import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { AnalyticsSyncWizardStep } from '@monorepo/shared/componentsV2/fullPageWizard/AnalyticsSyncWizardStep/AnalyticsSyncWizardStep';
import { Page } from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import { useDatasetForOrigin } from '@monorepo/shared/hooks/datasets/useDatasetByOrigin';
import React from 'react';
import { useParams } from 'react-router-dom';
import { EditResourceTypeHeader, WizardStep } from './EditResourceTypeHeader';

export function ResourceTypeAnalyticsSyncPage() {
  useDisableSubnav();

  const { organizationId, resourceTypeId } = useParams();
  if (!organizationId || !resourceTypeId) {
    throw new Error(
      'ResourceTypeAnalyticsSyncPage was rendered in a context without organization or/and resource type id',
    );
  }

  const { dataset, isLoading: isDatasetLoading } = useDatasetForOrigin({
    organizationId,
    originId: resourceTypeId,
  });

  if (isDatasetLoading) {
    return (
      <Page>
        <EditResourceTypeHeader wizardStep={WizardStep.ANALYTICS_SYNC} />
        <Loading />
      </Page>
    );
  }
  if (!dataset) {
    throw new Error("Couldn't get information about this Resource type.");
  }

  return (
    <Page>
      <EditResourceTypeHeader wizardStep={WizardStep.ANALYTICS_SYNC} />
      <ErrorBoundary>
        <AnalyticsSyncWizardStep
          datasetId={dataset.id}
          datasetOriginLabel="Resource type"
          organizationId={organizationId}
        />
      </ErrorBoundary>
    </Page>
  );
}
